/** Danh sách khách hàng */
export const CUSTOMER_LIST_PATH = "/quan-li-khach-hang";

/** Tạo khách hàng mới */
export const CUSTOMER_NEW_SEGMENT = "tao-moi";
export const CUSTOMER_NEW_PATH = `${CUSTOMER_LIST_PATH}/${CUSTOMER_NEW_SEGMENT}`;

/** @param {number|string|null|undefined} id */
export function customerDetailPath(id) {
  if (id == null || id === "" || String(id) === "0" || Number(id) === 0) {
    return CUSTOMER_NEW_PATH;
  }
  return `${CUSTOMER_LIST_PATH}/${id}`;
}

/** @param {number|string} id */
export function customerAddCodePath(id) {
  return `${CUSTOMER_LIST_PATH}/${id}/them-ma`;
}

/** @param {string|undefined} id — segment từ useParams */
export function isNewCustomerRouteId(id) {
  return (
    id === CUSTOMER_NEW_SEGMENT ||
    id == null ||
    id === "" ||
    String(id) === "0" ||
    Number(id) === 0
  );
}
